module.exports = "/logo-horizontal-4d24ea4b33597aab2179a6c915715569.svg";